<template>
  <div class="w-full h-full flex items-center justify-center relative">
    <input
      type="file"
      :accept="acceptedFilesTypes.join(',')"
      v-bind="inputProperties"
      @change="saveNewPicture"
      :class="{
        'pointer-events-none': !$slots.default,
      }"
      class="absolute w-full h-full opacity-0"
      ref="filePicker"
    />
    <slot>
      <div class="flex gap-1 items-center justify-between w-full px-2">
        <span
          block
          overflowEllipsis
          class="w-full"
          :class="{
            'text-primary-400': !fileName,
          }"
        >
          {{ fileName || placeHolder }}
        </span>
        <div
          class="buttonComponent small"
          :elasticHover="false"
          buttonClasses="m-0 "
          type="none"
          @click.prevent="
            () => {
              selectFile()
            }
          "
          :loading="savingFile"
          :disabled="savingFile"
        >
          Sélectionner
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import { savePicture } from '@/utils/plugins/savePicture'
import { defineComponent } from 'vue'
// import { savePicture } from '../../utils/plugins/savePicture.js'

export default defineComponent({
  name: 'PictureUploader',
  components: {},
  props: {
    acceptedFilesTypes: {
      type: Array,
      default: () => {
        return ['*']
      },
    },
    inputProperties: {
      type: Object,
      default: () => {
        return {}
      },
    },
    fileId: {
      type: String,
      default: '',
    },
    placeHolder: {
      type: String,
      default: '',
    },
    canUpload: {
      type: Boolean,
      default: true,
    },
    makeLoadingModal: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      savingFile: false,
      fileName: '',
    }
  },
  mounted() {},
  methods: {
    selectFile() {
      if (!this.canUpload) return
      this.$refs.filePicker.click()
    },
    async saveNewPicture(event) {
      const [file] = event.target.files
      if (!file) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Echec',
          body: 'Aucune image sélectionnée',
        })
        return
      }
      this.$emit('willUpload')
      this.uploadFile(file)
    },
    async uploadFile(file) {
      this.savingFile = true
      if (this.makeLoadingModal) {
        this.$Events.dispatchEvent('start_loading_dismissable', {
          title: 'Sauvegarde du contenu',
          subTitle:
            'Veuillez patienter pendant la sauvegarde de votre document',
          cancelText: 'Annuler',
        })
      } else {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Sauvegarde en cours',
          body: 'Veuillez patienter pendant la sauvegarde de votre document',
        })
      }
      const pictureSavingResponse = await savePicture(file)
      this.savingFile = false
      if (this.makeLoadingModal) {
        this.$Events.dispatchEvent('finish_loading')
      }
      if (!pictureSavingResponse.success) {
        this.$Events.dispatchEvent('toast_notification', {
          title: 'Erreur de sauvegarde',
          body: "Echec, nos serveur n'arrive pas à récupérer le ficher, veuillez réessayer",
        })
        this.$emit('uploadFailed')
        return
      }
      const fileUrl = pictureSavingResponse.data.fileUrl
      this.fileName = file.name
      const fileId =
        pictureSavingResponse.data.id + pictureSavingResponse.data.ext
      this.$emit('onFileChanged', fileId, file.name, fileUrl)
      console.log('emmit onFileChanged')
    },
  },
  computed: {},
})
</script>
